var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"picture-preview-container"},[_c('image-viewer',{ref:"imgViewer",attrs:{"z-index":9999,"initial-index":_vm.index,"url-list":_vm.imgList,"on-close":_vm.closeViewer}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eadbcb2a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form/runtime/components/picture-preview-swiper.vue
// module id = null
// module chunks = 